const ru = {
  // Legacy aliases
  add: 'Добавить', edit: 'Редактировать', save: 'Сохранить', cancel: 'Отмена', delete: 'Удалить',
  search: 'Поиск', export: 'Экспорт', download: 'Скачать', signIn: 'Войти',
  chassis: 'Шасси', make: 'Марка', model: 'Модель', year: 'Год', color: 'Цвет',
  mileage: 'Пробег', displacement: 'Объём двигателя', transmission: 'Трансмиссия',
  port: 'Порт', status: 'Статус', price: 'Цена', cost: 'Стоимость', fobPrice: 'Цена FOB',
  condition: 'Состояние', quantity: 'Количество', category: 'Категория', fitment: 'Совместимость',
  cutType: 'Тип распила', sku: 'Артикул', name: 'Имя', email: 'Эл. почта', password: 'Пароль',
  phone: 'Телефон', company: 'Компания', country: 'Страна', scan: 'Сканировать QR',
  priceQuotes: 'Ценовые предложения', selectionOrders: 'Заказы на выбор', pricing: 'Ценообразование',
  vehicles: 'Транспорт', engines: 'Двигатели', parts: 'Запчасти', containers: 'Контейнеры',
  customers: 'Клиенты', requests: 'Запросы', employees: 'Сотрудники', settings: 'Настройки',
  dashboard: 'Панель управления', inventory: 'Инвентарь', myStock: 'Мой склад',
  invoices: 'Счета', payments: 'Платежи', noData: 'Нет данных',
  loading: 'Загрузка...', totalUnits: 'Всего единиц', printQR: 'Печать QR',
  whatsAppInquiry: 'Запрос WhatsApp', viewDetails: 'Подробности',
  staffPortal: 'Портал сотрудников', customerPortal: 'Портал клиентов',
  invalidCredentials: 'Неверные данные',
  recentActivity: 'Недавняя активность', inventoryValue: 'Стоимость инвентаря',
  inTransit: 'В пути', pendingRequests: 'Ожидающие запросы',

  // Dashboard
  dash_welcome: 'Добро пожаловать, {name}',
  dash_good_morning: 'Доброе утро', dash_good_afternoon: 'Добрый день', dash_good_evening: 'Добрый вечер',
  dash_financial_overview: 'финансовый обзор',
  dash_units_in_account: 'единиц в вашем аккаунте',
  dash_my_shipments: 'Мои отправки', dash_on_the_way: 'В пути', dash_arrived: 'Прибыло',
  dash_no_shipments: 'Нет активных отправок',
  dash_recommended: 'Рекомендовано для вас', dash_available_units: 'Доступные единицы',
  dash_no_available: 'Нет доступных единиц.',
  dash_total_fob: 'Общая стоимость FOB', dash_total_cost: 'Общая себестоимость',
  dash_late_night: 'Доброй ночи', dash_hello: 'Привет',
  dash_subtitle: 'Обзор вашего автопарка, запчастей и входящих отправок — обновляется в реальном времени.',
  dash_local_time: 'МЕСТНОЕ ВРЕМЯ', dash_status: 'СТАТУС', dash_all_systems_live: 'Все системы работают',
  dash_view_recommendations: 'Посмотреть рекомендации', dash_my_stock: 'МОЙ СКЛАД', dash_in_transit: 'В ПУТИ',
  dash_units: 'единиц', dash_containers: 'контейнеров', dash_browse_more: 'Смотреть ещё',
  dash_track_shipments: 'Отслеживать отправки', dash_browse_inventory_start: 'Просмотрите каталог для начала',
  dash_no_active_shipments: 'Нет активных отправок', dash_next_eta: 'Прибытие через', dash_days: 'дней',
  dash_etas_confirming: 'Даты прибытия уточняются', dash_this_week: 'НА ЭТОЙ НЕДЕЛЕ',
  dash_arriving_soon: 'СКОРО ПРИБУДЕТ', dash_logistics: 'ЛОГИСТИКА', dash_active_shipments: 'Активные отправки',
  dash_view_all: 'Показать все', dash_shipment_empty: 'Ваша следующая отправка появится здесь, когда единицы будут загружены в контейнер',
  dash_composition: 'СОСТАВ', dash_stock_breakdown: 'Структура склада', dash_no_units_yet: 'Пока нет единиц',
  dash_browse_to_build: 'Просматривайте каталог, чтобы сформировать свой склад',
  dash_for_you: 'ДЛЯ ВАС', dash_picked_based: 'Подобрано на основе вашего склада', dash_browse_all: 'Смотреть все',
  dash_picking_units: 'Мы подбираем единицы для вас. Загляните позже или просмотрите весь каталог',
  dash_view_details: 'Подробнее', dash_just_arrived: 'ТОЛЬКО ПРИБЫЛО', dash_similar: 'ПОХОЖИЕ НА ВАШИ',
  dash_today: 'Сегодня', dash_tomorrow: 'Завтра',
  dash_gross_margin: 'Валовая маржа', dash_awaiting_pricing: 'Ожидает ценообразования',
  dash_vehicle_fob: 'FOB транспорта', dash_engine_fob: 'FOB двигателей',
  dash_parts_fob: 'FOB запчастей', dash_total_freight: 'Общая стоимость фрахта',
  dash_fob_by_make: 'FOB по маркам', dash_no_priced_vehicles: 'Нет оценённых транспортных средств',
  dash_top_units: 'Топ-5 единиц по FOB', dash_no_priced_units: 'Нет оценённых единиц',
  dash_margin: 'маржа', dash_container_breakdown: 'Финансовый анализ контейнеров',
  dash_no_containers: 'Нет контейнеров',
  dash_container: 'Контейнер', dash_route: 'Маршрут', dash_units: 'Единицы',
  dash_freight_cost: 'Стоимость фрахта', dash_fob_value: 'Стоимость FOB',
  dash_net_after_freight: 'Нетто после фрахта',
  dash_receivables: 'Дебиторская задолженность', dash_total: 'Всего', dash_current: 'Текущий',
  dash_overdue: 'Просрочено', dash_oldest: 'Самый старый', dash_days: 'дней',
  dash_this_month: 'В этом месяце', dash_invoiced: 'Выставлено счетов', dash_received: 'Получено',
  dash_avg_margin: 'Средняя маржа', dash_quotes_sent: 'Отправлено предложений',
  dash_pending_actions: 'Ожидающие действия', dash_receipts_verify: 'квитанций требуют проверки',
  dash_units_pricing: 'единиц требуют ценообразования', dash_invoices_overdue: 'просроченных счетов',
  dash_customer_balances: 'Балансы клиентов', dash_customer_overview: 'Обзор клиентов',
  dash_top_customers: 'Лучшие клиенты (по выручке)',
  dash_attention: 'Внимание', dash_no_customer_data: 'Нет данных о клиентах.',
  dash_no_customers: 'Нет клиентов', dash_no_activity: 'Нет недавней активности',
  dash_price_quotes: 'Ценовые предложения', dash_pending: 'Ожидание',
  dash_in_progress: 'В работе', dash_quoted_week: 'Оценено на этой неделе',
  dash_total_units: 'Всего единиц', dash_inventory_value: 'Стоимость инвентаря',
  dash_in_transit: 'В пути', dash_pending_requests: 'Ожидающие запросы',
  dash_shipped: 'Отправлено', dash_delivered: 'Доставлено',

  // Navigation
  nav_dashboard: 'Панель управления', nav_inventory: 'Инвентарь', nav_my_stock: 'Мой склад',
  nav_my_selection: 'Мой выбор', nav_containers: 'Контейнеры', nav_requests: 'Запросы',
  nav_invoices: 'Счета', nav_payments: 'Платежи', nav_customers: 'Клиенты',
  nav_employees: 'Сотрудники', nav_settings: 'Настройки', nav_pricing: 'Ценообразование',
  nav_price_quotes: 'Ценовые предложения', nav_selection_orders: 'Заказы на выбор',
  nav_tasks: 'Задачи',
  nav_scan: 'Сканировать', nav_sign_out: 'Выйти',

  // Buttons
  btn_save: 'Сохранить', btn_cancel: 'Отмена', btn_delete: 'Удалить', btn_edit: 'Редактировать',
  btn_add: 'Добавить', btn_submit: 'Отправить', btn_approve: 'Одобрить', btn_reject: 'Отклонить',
  btn_download: 'Скачать', btn_upload: 'Загрузить', btn_search: 'Поиск', btn_export: 'Экспорт',
  btn_clear: 'Очистить', btn_confirm: 'Подтвердить', btn_close: 'Закрыть', btn_view: 'Просмотр',
  btn_remove: 'Удалить', btn_back: 'Назад', btn_next: 'Далее',
  btn_save_changes: 'Сохранить изменения', btn_sign_in: 'Войти', btn_contact_us: 'Связаться',

  // Login
  login_title: 'BIG STAR', login_subtitle: 'Управление экспортом автомобилей',
  login_staff_portal: 'Портал сотрудников', login_customer_portal: 'Портал клиентов',
  login_username: 'Имя пользователя', login_email: 'Эл. почта', login_password: 'Пароль',
  login_remember: 'Запомнить', login_invalid: 'Неверные данные',
  login_timeout: 'Сессия истекла. Войдите снова.',

  // Inventory
  inv_add_to_stock: 'Добавить в мой склад', inv_in_stock: 'В моём складе',
  inv_reserved: 'Зарезервировано', inv_sold: 'Продано', inv_available: 'Доступно',
  inv_search_placeholder: 'Поиск транспорта, запчастей, двигателей...',
  inv_no_results: 'Ничего не найдено', inv_vehicle: 'Транспорт', inv_engine: 'Двигатель',
  inv_spare_part: 'Запчасть', inv_vehicles: 'Транспорт', inv_engines: 'Двигатели',
  inv_parts: 'Запчасти', inv_all: 'Все', inv_no_data: 'Нет данных',
  inv_all_items: 'Все элементы', inv_all_status: 'Все статусы', inv_all_makes: 'Все марки',
  inv_all_years: 'Все годы', inv_all_transmissions: 'Все трансмиссии',
  inv_all_conditions: 'Все состояния', inv_all_categories: 'Все категории',
  inv_all_countries: 'Все страны', inv_item: 'Элемент', inv_details: 'Подробности',
  inv_days: 'Дни', inv_show: 'Показать', inv_request_parts: 'Запросить запчасти',
  inv_how_want_vehicle: 'Как вы хотите получить этот транспорт?',
  inv_full_vehicle: 'Целый транспорт', inv_full_vehicle_desc: 'Полностью как есть',
  inv_custom: 'На заказ', inv_custom_desc: 'Опишите ваш запрос',

  // Detail labels
  detail_make: 'Марка', detail_model: 'Модель', detail_year: 'Год', detail_chassis: 'Шасси',
  detail_color: 'Цвет', detail_mileage: 'Пробег', detail_grade: 'Класс', detail_score: 'Оценка',
  detail_engine_code: 'Код двигателя', detail_transmission: 'Трансмиссия',
  detail_fuel: 'Тип топлива', detail_steering: 'Руль', detail_drive: 'Привод',
  detail_condition: 'Состояние', detail_status: 'Статус', detail_price: 'Цена',
  detail_fob: 'Цена FOB', detail_displacement: 'Объём двигателя',
  detail_port: 'Порт', detail_city: 'Город', detail_seats: 'Места',
  detail_category: 'Категория', detail_fitment: 'Совместимость', detail_quantity: 'Количество',
  detail_sku: 'Артикул', detail_cut_type: 'Тип распила', detail_photos: 'Фото',
  detail_notes: 'Заметки', detail_location: 'Расположение', detail_manufacturer: 'Производитель',
  detail_assign_customer: 'Назначить клиенту', detail_assigned_to: 'Назначен',
  detail_request_parts: 'Запросить запчасти из этого транспорта',

  // Statuses
  status_available: 'Доступно', status_assigned: 'Назначено', status_sold: 'Продано',
  status_shipped: 'Отправлено', status_in_transit: 'В пути', status_at_port: 'В порту',
  status_customs: 'Таможня', status_delivered: 'Доставлено', status_japan_yard: 'Площадка Японии',
  status_loading: 'Погрузка', status_loaded: 'Погружено', status_pending: 'Ожидание',
  status_approved: 'Одобрено', status_rejected: 'Отклонено', status_planning: 'Планирование',
  status_booked: 'Забронировано', status_sealed: 'Опечатано', status_closed: 'Закрыто',

  // Stock
  stock_title: 'Мой склад', stock_available_section: 'Доступные единицы',
  stock_in_review: 'На проверке', stock_approved_section: 'Одобрено',
  stock_empty: 'Ваш склад пуст.', stock_request_quote: 'Запросить цену',
  stock_quote_requested: 'Цена запрошена', stock_price_pending: 'Цена ожидается',
  stock_my_orders: 'Мои заказы',

  // Selection
  sel_units_selected: '{count} единиц выбрано', sel_total: 'Итого', sel_continue: 'Продолжить',
  sel_submit: 'Отправить финальный выбор', sel_review_title: 'Проверьте ваш выбор',

  // Containers
  cont_title: 'Контейнеры', cont_no_containers: 'Контейнеров пока нет.',
  cont_destination: 'Назначение', cont_eta: 'Ожидаемое прибытие', cont_seal: 'Номер пломбы',
  cont_download_bl: 'Скачать коносамент', cont_arrived: 'Контейнер прибыл',
  cont_new_container: 'Новый контейнер', cont_freight: 'Фрахт',

  // Invoices
  invoice_title: 'Счета', invoice_action_required: 'Требуется действие',
  invoice_total_invoiced: 'Выставлено', invoice_total_paid: 'Оплачено',
  invoice_outstanding: 'К оплате', invoice_overdue: 'Просрочено',
  invoice_upload_receipt: 'Загрузить квитанцию', invoice_download_pdf: 'Скачать PDF',
  invoice_no_invoices: 'Нет счетов', invoice_empty_msg: 'Счета появятся здесь при создании.',

  // Payments
  pay_title: 'Платежи', pay_verified: 'Проверенные платежи',
  pay_no_verified: 'Проверенных платежей пока нет.',
  pay_add: 'Добавить платёж', pay_outgoing: 'Исходящие платежи',
  pay_no_outgoing: 'Исходящих платежей не зафиксировано.',
  pay_verify: 'Подтвердить', pay_reject: 'Отклонить',

  // Selection Orders
  selorder_title: 'Заказы на выбор', selorder_no_orders: 'Нет заказов на выбор',
  selorder_empty_msg: 'Заказы клиентов появятся здесь при подаче.',

  // Requests
  req_title: 'Запросы', req_new: 'Новый запрос', req_reply: 'Ответить',

  // Settings
  settings_title: 'Настройки', settings_profile: 'Мой профиль',
  settings_name: 'Имя', settings_phone: 'Телефон',

  // Common UI
  ui_all_customers: 'Все клиенты', ui_export_csv: 'Экспорт CSV',
  ui_edit: 'Редактировать', ui_delete: 'Удалить', ui_download: 'Скачать',

  // Condition
  cond_good: 'Хорошее', cond_minor_damage: 'Незначительный ущерб',
  cond_major_damage: 'Серьёзный ущерб', cond_missing_parts: 'Отсутствуют детали',

  // Notifications
  notif_title: 'Уведомления', notif_no_new: 'Нет новых уведомлений',

  // Misc
  misc_all_customers: 'Все клиенты', misc_no_data: 'Нет данных', misc_loading: 'Загрузка...',
  misc_country: 'Страна', misc_currency: 'Валюта',
};
export default ru;
